import React from "react";
import { Button, Select, Flex } from "@chakra-ui/react";
const Header = ({ selectValue, onChangeEvent, onClickEvent }) => {
  return (
    <Flex>
      <Select
        w="135px"
        h="32px"
        placeholder="Bulk actions"
        bg="white"
        borderColor="black"
        value={selectValue}
        onChange={(e) => onChangeEvent(e)}
      >
        <option value="delete">Delete</option>
      </Select>
      <Button
        ml="2"
        size="md"
        h="32px"
        color="#2271b1"
        colorScheme="teal"
        variant="outline"
        borderColor="#2271b1"
        onClick={(e) => onClickEvent(e)}
      >
        Apply
      </Button>
    </Flex>
  );
};

export default Header;
